/*
 * @Author: zhaozhuo
 * @Date: 2021-12-06 15:03:07
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2024-02-21 18:15:55
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\request\api\research.js
 */
import { get, post } from '../axios'
const research = {
	// 患者端研究列表
	getTesteeResearchList: (params) => get(`/web/weixin/queryResearchList/${params}`),
	// 单查研究
	getResearchById: params => get(`/web/research/getResearchById/${params}`),
	// 医生端研究列表
	getDoctorResearchList: params => post('/web/research/getResearchList', params),
	// 所有研究列表
	getResearchListforcode: () => get('/web/research/getResearchListforcode'),
	// 获取患教知识
	getPreachById: id => get(`/web/announcement/getResearchById/${id}`),
	//
	fetchSysConfigSelect: params => get('/web/sys/config/querySystemInfo', params)
}
export default research
